import { makeIcon } from 'bootstrap-vue/esm/icons/helpers/make-icon'
import string from '@/assets/js/helper/string'

function createCustomIcons (context) {
  return context
    .keys()
    .reduce((exports, key) => {
      const name = string.pascalCase(key.replace(/(^.\/|.svg$)/g, ''))
      const svgContentRegexp = /<svg[^>]+>((?:.|[\n\r\u2028\u2029])+)<\/svg>/gm
      const matches = svgContentRegexp.exec(context(key).default)
      const path = matches[1]
      const icon = makeIcon(name, path)

      return Object.assign(exports, { [icon.extendOptions.name]: icon })
    }, {})
}

export default createCustomIcons(require.context('@/../public/icons', true, /.\.svg$/))
